export const EARTH_RADIUS_KM = 6378.1

export const MAP_CENTER = { lat: 59.95, lng: 30.33 }

export const MAP_ZOOM = 12

export const GEOMETRY_CHANGE_DEBOUNCE_MS = 200
